// src/Card.js
import React from "react";
import "./Card.css";

const Card = ({ testimonial, author, avatar }) => {
  return (
    <article className="card">
      <div className="card-header">
        <h2>{testimonial}</h2>
      </div>

      <div className="card-author">
        <div className="author-avatar">
          <img src={avatar} alt={`${author}'s avatar`} />
        </div>
        <svg className="half-circle" viewBox="0 0 106 57">
          <path d="M102 4c0 27.1-21.9 49-49 49S4 31.1 4 4"></path>
        </svg>

        <div className="author-name">
          <div className="author-name-prefix">Student</div>
          {author}
        </div>
      </div>
    </article>
  );
};

export default Card;
